module.exports = __webpack_public_path__ + "static/vokabox-favicon-965e1545e947e7fa4dcdb690e627e202.png";